import React from 'react';
import {Modal, Tag, Spin} from 'antd'
import {Row, Col} from 'reactstrap';
import {useRecoilValue} from 'recoil';
import {userData} from "../../recoil_store";
import './Profile.css';

const Profile = ({toggleModal, visible}) => {
    const {email, picture, subscriptions, loading} = useRecoilValue(userData)
    return (
        <Modal
            title="Profile"
            visible={visible}
            onCancel={() => toggleModal(false)}
            footer={null}>
            <div className="well profile">
                {loading ? <Spin/> : (
                    <Row>
                        <Col xs="12" sm="4" className="text-center">
                            <figure>
                                <img
                                    src={picture}
                                    alt="" className="img-circle img-responsive"/>
                            </figure>
                        </Col>
                        <Col xs="12" sm="8">
                            <h4>{email}</h4>
                            <Tag color="#2db7f5">{subscriptions.planName}</Tag>
                            <hr/>
                            <p>Total Remaining Minutes per Month : {subscriptions.totalMinutes}</p>
                            <p>Remaining Files per Month : {subscriptions.filesLimit}</p>
                            <p>Media Length : {subscriptions.mediaLimit} minutes</p>
                            <p>Remaining words for document  : {subscriptions.wordsLimit}</p>
                        </Col>
                    </Row>
                )}
            </div>
        </Modal>
    )
}

export {Profile}